import { Box, Typography } from '@material-ui/core';
import { alpha, useTheme } from '@material-ui/core/styles';
import { CompareArrows } from '@material-ui/icons';
import { motion } from 'framer-motion';

// ----------------------------------------------------------------------

export default function MaterialTransferLoader({ message = 'Transferring material...', compact = false }) {
  const theme = useTheme();
  const primary = theme.palette.primary.main;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: compact ? 2 : 3,
        px: 2,
        width: '100%',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: compact ? 160 : 220,
          height: compact ? 64 : 88,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: compact ? 1.5 : 2.5,
        }}
      >
        <Box
          component={motion.div}
          animate={{ x: [0, 6, 0], opacity: [0.85, 1, 0.85] }}
          transition={{ duration: 1.4, repeat: Infinity, ease: 'easeInOut' }}
          sx={{
            width: compact ? 32 : 40,
            height: compact ? 32 : 40,
            borderRadius: 1,
            bgcolor: alpha(primary, 0.12),
            border: `2px solid ${primary}`,
            boxShadow: `0 4px 12px ${alpha(primary, 0.2)}`,
          }}
        />
        <Box
          component={motion.div}
          animate={{ opacity: [0.5, 1, 0.5], scale: [0.92, 1.08, 0.92] }}
          transition={{ duration: 1.1, repeat: Infinity, ease: 'easeInOut' }}
          sx={{ mx: 1.5, display: 'flex', alignItems: 'center' }}
        >
          <CompareArrows sx={{ fontSize: compact ? 32 : 44, color: primary }} />
        </Box>
        <Box
          component={motion.div}
          animate={{ x: [0, -6, 0], opacity: [0.85, 1, 0.85] }}
          transition={{ duration: 1.4, repeat: Infinity, ease: 'easeInOut', delay: 0.35 }}
          sx={{
            width: compact ? 32 : 40,
            height: compact ? 32 : 40,
            borderRadius: 1,
            bgcolor: alpha(primary, 0.2),
            border: `2px dashed ${primary}`,
            boxShadow: `0 4px 12px ${alpha(primary, 0.15)}`,
          }}
        />
        <Box
          component={motion.div}
          animate={{ left: ['18%', '82%'], opacity: [0, 1, 0] }}
          transition={{ duration: 1.6, repeat: Infinity, ease: 'easeInOut' }}
          sx={{
            position: 'absolute',
            top: '50%',
            width: 10,
            height: 10,
            mt: '-5px',
            borderRadius: '50%',
            bgcolor: primary,
          }}
        />
      </Box>

      <Typography
        variant={compact ? 'body2' : 'subtitle1'}
        sx={{ color: 'text.primary', fontWeight: 600, textAlign: 'center' }}
      >
        {message}
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, textAlign: 'center' }}>
        Moving inventory between facilities
      </Typography>

      <Box sx={{ display: 'flex', gap: 0.75, mt: compact ? 1.5 : 2 }}>
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            component={motion.div}
            animate={{ opacity: [0.25, 1, 0.25], scale: [0.85, 1.15, 0.85] }}
            transition={{ duration: 0.9, repeat: Infinity, delay: i * 0.18 }}
            sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: primary }}
          />
        ))}
      </Box>
    </Box>
  );
}
